import React from 'react'

import SelectComparablePropertySkeleton from '@components/compare-property/skeleton'

import { ComparableProperty, PropertyType } from '@adUtilities/types'

import ComparableLotItem from './comparable-lot-item'
import ComparableUnitItem from './comparable-unit-item'

interface ComparablePropertyItemProps {
  comparableProperty: ComparableProperty
  showPropertyInfo?: boolean
}

function ComparablePropertyItem({
  comparableProperty,
  showPropertyInfo,
}: ComparablePropertyItemProps) {
  if (!comparableProperty.property) {
    return <SelectComparablePropertySkeleton />
  }

  if (comparableProperty.property.propertyType === PropertyType.Unit) {
    return (
      <ComparableUnitItem
        unit={comparableProperty.property.data}
        showInfo={showPropertyInfo}
      />
    )
  }

  if (comparableProperty.property.propertyType === PropertyType.Lot) {
    return (
      <ComparableLotItem
        comparableLot={comparableProperty.property}
        showInfo={showPropertyInfo}
      />
    )
  }

  return null
}

export default ComparablePropertyItem
